module.exports = __webpack_public_path__ + "img/idCardBack.e7afcb95.png";